import { Article } from '@api/api';
// import { ArticleCard } from '@components/common/Card/ArticleCard';
import { DataFeed } from '@components/common/DataFeed';
import { useCurrentPaginationPage, usePagination } from '@hooks/usePagination';
import { useLatestStories } from '@queries/useLatestStories';
import { MEDIA_QUERIES, useMediaQuery } from '@student-coin/coinpaper-components';
import { buildArticleLink } from '@utils/link';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';
import { FunctionComponent } from 'react';
import { Heading } from '../shared/Heading';
import { LatestStoriesProps } from './LatestStories.types';
import { Section } from './LatestStories.styles';

const ArticleCard = dynamic(
  () => import('@components/common/Card/ArticleCard').then((mod) => mod.ArticleCard),
  { ssr: true },
);

export const LatestStories: FunctionComponent<LatestStoriesProps> = ({ loadMoreText }) => {
  const currentPage = useCurrentPaginationPage();

  const { data: articles, totalPages, isFetching } = useLatestStories(currentPage);

  const { onPageChange } = usePagination(currentPage, totalPages);

  const { t } = useTranslation('home');
  const isTabletWide = useMediaQuery(MEDIA_QUERIES.tablet);

  return (
    <Section>
      <Heading>{t('latest')}</Heading>

      <DataFeed<Article>
        data={(articles as { items?: Article[] })?.items}
        hideHeader
        loading={isFetching}
        loadMoreText={loadMoreText}
        renderData={(article: Article) => (
          <ArticleCard
            key={article.id}
            href={buildArticleLink(article.id, article.slug)}
            article={article}
            thumbnail={isTabletWide ? 'left' : 'top'}
            variant="large"
            withDescription={isTabletWide}
            descriptionLimit={isTabletWide ? 3 : 0}
            size={isTabletWide ? 'small' : 'large'}
          />
        )}
        variant="list"
        onPageChange={onPageChange}
        totalPages={totalPages}
        activePage={currentPage}
      />
    </Section>
  );
};
